module.exports = __webpack_public_path__ + "img/andrcleaning.ce4eb6a0.jpeg";